// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Organization {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  primary_color: string;
  secondary_color: string;
  access_tier: 'full_access' | 'export_only';
  status: 'active' | 'trial' | 'inactive';
}

const DEFAULT_ORGANIZATION: Organization = {
  id: '4a900125-64a5-4a26-b5f6-860fd278a186', // RecruitLook Events organization UUID
  name: 'RecruitLook Events',
  slug: 'recruitlook-events',
  logo_url: null,
  primary_color: '#002E62',
  secondary_color: '#BC8D09',
  access_tier: 'full_access',
  status: 'active',
};

export function useOrganization() {
  const { data: organization, isLoading, error } = useQuery<Organization, Error>({
    queryKey: ['organization', window.location.hostname],
    queryFn: async () => {
      try {
        const hostname = window.location.hostname;

        if (hostname === 'localhost' || hostname.includes('lovable.app')) {
          return DEFAULT_ORGANIZATION;
        }

        const { data: domainData, error: domainError } = await supabase
          .from('organization_domains')
          .select('organization_id, organizations!inner(*)')
          .eq('domain', hostname)
          .eq('verified', true)
          .maybeSingle();

        if (domainError) {
          console.error('useOrganization: domain query failed', domainError);
          return DEFAULT_ORGANIZATION;
        }

        if (!domainData) return DEFAULT_ORGANIZATION;

        const org = (domainData as any).organizations;
        if (!org) return DEFAULT_ORGANIZATION;

        return {
          id: org.id,
          name: org.name,
          slug: org.slug,
          logo_url: org.logo_url,
          primary_color: org.primary_color,
          secondary_color: org.secondary_color,
          access_tier: org.access_tier,
          status: org.status,
        };
      } catch (err) {
        console.error('useOrganization: unexpected error', err);
        return DEFAULT_ORGANIZATION;
      }
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
  });

  return {
    organization: organization || DEFAULT_ORGANIZATION,
    isLoading,
    error,
  };
}
